import axiosInstance from 'axiosInstance';

export const fetchPartnerDashboard = async () => {
  const response = await axiosInstance.get('waitlist/partner-dashboard');
  return response.data;
};

export const rotatePartnerBenefitLink = async (benefitChoice) => {
  const response = await axiosInstance.post('waitlist/partner-dashboard/rotate-link', {
    benefit_choice: benefitChoice,
  });
  return response.data;
};
